export const handleRedirectAndClose = (metadata, walletKit) => {
    if (typeof window === 'undefined')
        return;
    let redirectUrl;
    if (metadata) {
        redirectUrl = metadata.redirect?.native;
    }
    else if (walletKit) {
        // For cases where we need to get redirect from active sessions
        const sessions = walletKit.getActiveSessions();
        if (!sessions)
            return;
        const topic = Object.keys(sessions)[0];
        if (!topic)
            return;
        redirectUrl = sessions[topic].peer.metadata.redirect?.native;
    }
    // Mobile behavior
    const isMobile = /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
    if (isMobile && redirectUrl) {
        // Listen for visibility changes
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
                // The page is being hidden (likely due to redirect), try to close
                window.close();
            }
        });
        // Initiate the redirect
        window.location.assign(redirectUrl);
        return;
    }
    // Desktop behavior
    window.close();
};
//# sourceMappingURL=Redirect.js.map